import { render, staticRenderFns } from "./CoproffStatsFragil.vue?vue&type=template&id=82c1bc14&scoped=true"
import script from "./CoproffStatsFragil.vue?vue&type=script&lang=js"
export * from "./CoproffStatsFragil.vue?vue&type=script&lang=js"
import style0 from "./CoproffStatsFragil.vue?vue&type=style&index=0&id=82c1bc14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82c1bc14",
  null
  
)

export default component.exports